import { UserTypes } from "./UserTypes";
import { SubscriptionStatus } from "../Subscriptions/SubscriptionStatus";
import { SubscriptionRecurrenceType } from "../Subscriptions/SubscriptionRecurrenceType";
import { NutrientSource } from "../NutrientSource/NutrientSource";

// export default interface UserDetails {
//     autoRenewal: boolean;
//     email: string;
//     firstName: string;
//     hasWebAccess: boolean;
//     id: number;
//     impersonatedByAdministratorId: number;
//     isInitialPayment: boolean;
//     lastName: string;
//     localization: string;
//     restaurantId: number;
//     restaurantName: string;
//     subscriptionEndDate: string;
//     subscriptionName: string;
//     subscriptionPackageId: number;
//     subscriptionRecurrenceType: SubscriptionRecurrenceType;
//     subscriptionStartDate: string;
//     subscriptionStatus: SubscriptionStatus;
//     subscriptionType: SubscriptionTypes;
//     userType: UserTypes;
// }

class UserDetails {
  constructor(
    // tslint:disable-next-line:variable-name
    private _userType: UserTypes,
    public email: string,
    protected localization: string,
    public isRecipeOrDishLimitExceeded: boolean = false,
    protected _id?: number,
    protected restaurantId?: number,
    protected restaurantName?: string,
    protected subscriptionName?: string,
    protected isTrial?: boolean,
    public subscriptionStatus?: SubscriptionStatus,
    protected subscriptionStartDate?: Date,
    protected subscriptionEndDate?: Date,
    protected subscriptionCycle?: SubscriptionRecurrenceType,
    protected hasDraftSubscription?: boolean,
    protected availableNutrientSources?: NutrientSource[],
    protected isRecurring?: boolean,
    protected _subscriptionPackageId?: number,
    public firstName?: string,
    public lastName?: string,
    protected restaurantNotificationEmail?: string,
    public addOns?: [],
    protected phone?: string,
    protected freeUserLicenses?: number,
    protected paidUserLicenses?: number
  ) {
    this._id = _id;
    this.restaurantId = restaurantId;
    this.restaurantName = restaurantName;
    this.subscriptionName = subscriptionName;
    this.subscriptionStartDate = subscriptionStartDate;
    this.subscriptionEndDate = subscriptionEndDate;
    this.subscriptionCycle = subscriptionCycle;
    this.hasDraftSubscription = hasDraftSubscription;
    this.availableNutrientSources = availableNutrientSources;
    this._userType = _userType;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.localization = localization;
    this.isTrial = isTrial;
    this.subscriptionStatus = subscriptionStatus;
    this._subscriptionPackageId = _subscriptionPackageId;
    this.restaurantNotificationEmail = restaurantNotificationEmail;
    this.addOns = addOns;
    this.isRecurring = isRecurring;
    this.phone = phone;
    this.isRecipeOrDishLimitExceeded = isRecipeOrDishLimitExceeded;
    this.freeUserLicenses = freeUserLicenses;
    this.paidUserLicenses = paidUserLicenses;
  }

  get userType(): UserTypes {
    return this._userType;
  }

  get subscriptionPackageId(): number {
    return this._subscriptionPackageId as number;
  }
}

export default UserDetails;
